export default __webpack_public_path__ + "static/media/268.3409ea6a.png";